import React, { useState } from "react";
import TextField from "@material-ui/core/TextField";
import IconButton from "@material-ui/core/IconButton";
import InputAdornment from "@material-ui/core/InputAdornment";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";

export default function PasswordTextField({
  InputProps,
  isVisible: controlledVisibility,
  onVisibilityChange,
  ...props
}) {
  const [internalVisibility, setInternalVisibility] = useState(false);
  const isVisible =
    controlledVisibility === undefined
      ? internalVisibility
      : controlledVisibility;
  const toggleVisibility = () => {
    const nextVisibility = !isVisible;

    if (onVisibilityChange) {
      onVisibilityChange(nextVisibility);
    } else {
      setInternalVisibility(nextVisibility);
    }
  };

  return (
    <TextField
      {...props}
      type={isVisible ? "text" : "password"}
      InputProps={{
        ...InputProps,
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label={
                isVisible ? "Ocultar contraseña" : "Mostrar contraseña"
              }
              onClick={toggleVisibility}
              onMouseDown={(event) => event.preventDefault()}
              edge="end"
            >
              {isVisible ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
}
